module.exports = __webpack_public_path__ + "frontend/images/agents/provide-painting-ff98cf1bb1577dd53dd7c4bdddc03e8d.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/agents/provide-painting.png
// module id = 369
// module chunks = 2